export default "__VITE_ASSET__Fz$FAObh__"